export const createCertificationStepsRequests = (client) => ({
    listCertificationSteps: async (params) => {
        const { data, meta, links } = await client.api.get("certification_steps", {
            params: params,
        });
        return { data, meta, links };
    },
    findCertificationStep: async (params) => {
        const { data } = await client.api.get(`certification_steps/${params?.filter?.id}`, {
            params: params,
        });
        return { data };
    },
    createCertificationStep: async (payload) => {
        const { data } = await client.api.create("certification_steps", payload);
        return { data };
    },
    updateCertificationStep: async (payload) => {
        const { data } = await client.api.update("certification_steps", payload);
        return { data };
    },
    deleteCertificationStep: async (payload) => {
        const { data } = await client.api.delete("certification_steps", payload);
        return { data };
    },
    startPracticeStepRun: async (payload) => {
        const { data } = await client.api.request({
            type: "certification_steps",
            url: "/certification_steps/practice/start",
            body: payload,
            method: "POST",
        });
        return { data };
    },
    startTheoryStepRun: async (payload) => {
        const { data } = await client.api.request({
            type: "certification_steps",
            url: "/certification_steps/theory/start",
            body: payload,
            method: "POST",
        });
        return { data };
    },
    submitCertificationStepExam: async (payload) => {
        const { data } = await client.api.request({
            type: "certification_steps",
            url: "/certification_steps/theory/submit",
            body: payload,
            method: "POST",
        });
        return { data };
    },
});
//# sourceMappingURL=index.js.map